export const POST_BRAND_REGISTRATION = "POST_BRAND_REGISTRATION";
export const SET_BRAND_REGISTRATION = "SET_BRAND_REGISTRATION";
export const GET_BRAND_REGISTRATION = "GET_BRAND_REGISTRATION";
export const UPDATE_BRAND_REGISTRATION = "UPDATE_BRAND_REGISTRATION";
export const SUBMIT_BRAND_REGISTRATION = "SUBMIT_BRAND_REGISTRATION";
export const RESUBMIT_BRAND_REGISTRATION = "RESUBMIT_BRAND_REGISTRATION";
